import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { IProduct, ProductPatchModeOffline } from '@/tpss/types';
import { message } from 'tdesign-react';

interface ProductItemProps {
  product: IProduct;
}

const ProductItem: React.FC<ProductItemProps> = ({ product }) => {
  const navigate = useNavigate();
  const onClick = () => {
    if (product.ProductPatchMode === ProductPatchModeOffline) {
      message.info(`${product.ProductName} 产品站点建设中！`);
      return;
    }
    navigate(`/product/${product.ID}/package/0`);
  };

  return (
    <>
      <section className={styles.productItem} onClick={onClick}>
        <header className={styles.headerWrapper}>
          <img className={styles.icon} src={product.ProductIcon} alt="" />
          <h4 className={styles.title}>{product.ProductName}</h4>
        </header>
        {product.ProductDescription && (
          <div className={styles.desc}>{product.ProductDescription}</div>
        )}
        <div className={styles.footerWrapper}>
          <p className={styles.title}>查看详情</p>
        </div>
      </section>
    </>
  );
};

export default ProductItem;
